import styled from 'styled-components';
import { Colors } from '../../../assets/styles/StyleTypes';

export const Badge = styled.span`
  position: absolute;
  top: 0.125rem;
  right: 0.125rem;
  display: inline-flex;
  min-width: 1.25rem;
  height: 1.25rem;
  align-items: center;
  justify-content: center;
  padding: 0 0.25rem;
  border: 0.0625rem solid ${Colors.HIGH_LIGHTEST};
  border-radius: 0.625rem;
  background: ${({ theme }) => theme.colors.cancellationButton};
  color: ${Colors.HIGH_LIGHTEST};
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1;
  pointer-events: none;
  white-space: nowrap;
`;

export const LiveRegion = styled.span`
  position: fixed;
  width: 0.0625rem;
  height: 0.0625rem;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`;
